import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { difference } from 'lodash'
import { t } from 'translation'

import SettingsSaveFilesSongList from './SettingsSaveFilesSongList'
import Spinner from 'components/ui/Spinner/Spinner'

import { downloadSongs, toggleDownloadInBackground } from 'store/actions'

class SettingsSaveFilesSelect extends Component {
  state = {
    selectedSongs: new Set(),
  }

  allSongsIds = this.props.allSongs.map(({ songId }) => songId)

  setSelectedSongs = (selectedSongs) =>
    this.setState({ selectedSongs: new Set(selectedSongs) })

  toggleSelectAll = () => {
    const allIdsThatCanBeSelected = difference(
      this.allSongsIds,
      this.props.downloadedSongs
    )

    return this.state.selectedSongs.size < allIdsThatCanBeSelected.length
      ? this.setSelectedSongs(allIdsThatCanBeSelected)
      : this.setSelectedSongs([])
  }

  getSongInfoForDisplay = (selectedSongId) => {
    const song = this.props.allSongsMap[selectedSongId]
    if (!song) return

    const { title, artist } = song

    return (
      <span>
        <span className="popup_downloading_display_text_italic">{title}</span>{' '}
        {t('alarm.BY')}{' '}
        <span className="popup_downloading_display_text_italic">{artist}</span>
      </span>
    )
  }

  downloadSelectedSongsHandler = () => {
    const isIosOrAndroid =
      window.cordova &&
      (window.device?.platform === 'iOS' || window.device?.platform === 'Android')

    if (!isIosOrAndroid) return

    if (this.props.isDownloading) return this.props.toggleDownloadInBackground()

    const onlyNotDownloadedSongs = difference(
      [...this.state.selectedSongs],
      this.props.downloadedSongs
    )
    this.props.downloadSongs(onlyNotDownloadedSongs, this.props.allSongsMap)
  }

  componentDidMount() {
    if (this.props.isOnline && !this.props.isFetchingSongsFromRemote) return

    alert(t('settings.NOT_CONNECTED_TO_THE_INTERNET'))
    this.props.closeSaveFilesSelectHandler()
  }

  render() {
    const allIdsThatCanBeSelected = difference(
      this.allSongsIds,
      this.props.downloadedSongs
    )

    const allSelected = this.state.selectedSongs.size === allIdsThatCanBeSelected.length

    // Note: component reused from alarm submenu, so many of the same classes prefixed with 'alarm_...' are reused
    return (
      <div className="popup alarm_mod" onClick={(e) => e.stopPropagation()}>
        <button
          className="close_btn right_pos_mod alarm_mod"
          onClick={this.props.closeSaveFilesSelectHandler}
        ></button>
        <div className="popup_in">
          <div className="popup_content">
            <h2 className="section_title offset_mod alarm_mod">
              {t('settings.DOWNLOAD_MUSIC')}
            </h2>
            <div className="section_subtitle v2_mod">
              {t('settings.DOWNLOAD_MUSIC_DESC')}
            </div>
          </div>
          <div className="alarm_container sm_mod">
            <div className="btn_add_group">
              <button
                className="btn_add save_files_mod"
                onClick={this.downloadSelectedSongsHandler}
                disabled={
                  (!this.props.isDownloading &&
                    (this.state.selectedSongs.size === 0 ||
                      difference(
                        [...this.state.selectedSongs],
                        this.props.downloadedSongs
                      ).length === 0)) ||
                  !this.props.isOnline
                }
              >
                {this.props.isDownloading
                  ? t('settings.DOWNLOADING_IN_BACKGROUND')
                  : t('settings.START_DOWNLOAD')}
              </button>
              <button className="btn_add save_files_mod" onClick={this.toggleSelectAll}>
                {allSelected ? t('settings.DESELECT_ALL') : t('settings.SELECT_ALL')}
              </button>
            </div>
            <SettingsSaveFilesSongList
              setSelectedSongsHandler={this.setSelectedSongs}
              selectedSongs={new Set(this.state.selectedSongs)}
              downloadedSongs={this.props.downloadedSongs}
            />
          </div>
        </div>
        {this.props.isDownloading && !this.props.downloadInBackground ? (
          <div className="popup_downloading_overlay">
            <Spinner>
              <div className="popup_downloading_display_group">
                <div className="popup_downloading_display_text">
                  {t('settings.DOWNLOADING')}:{' '}
                  <span className="popup_downloading_display_text_bold">
                    {this.props.downloadNumber}/{this.props.downloadNumberTotal}
                  </span>
                </div>
                <div className="popup_downloading_display_text">
                  {this.getSongInfoForDisplay(this.props.downloadId)}
                </div>
                <div className="popup_downloading_display_text">
                  <span className="popup_downloading_display_text_bold">
                    {this.props.downloadProgress}%
                  </span>
                </div>
                <button
                  className="btn_add download_mod"
                  onClick={() => (
                    this.props.toggleDownloadInBackground(),
                    this.props.closeSaveFilesSelectHandler(),
                    this.props.closeModalHandler()
                  )}
                >
                  {t('settings.DOWNLOAD_BACKGROUND')}
                </button>
              </div>
            </Spinner>
          </div>
        ) : null}
      </div>
    )
  }
}

const mapStateToProps = ({
  auth: { isOnline },
  download: {
    downloadedSongs,
    downloadId,
    downloadInBackground,
    downloadNumber,
    downloadNumberTotal,
    downloadProgress,
    isDownloading,
  },
  player: { allSongs, allSongsMap, isFetchingSongsFromRemote },
}) => ({
  allSongs,
  allSongsMap,
  downloadedSongs,
  downloadId,
  downloadProgress,
  downloadNumber,
  downloadNumberTotal,
  downloadInBackground,
  isDownloading,
  isOnline,
  isFetchingSongsFromRemote,
})

const willMapDispatchToProps = { downloadSongs, toggleDownloadInBackground }

export default connect(mapStateToProps, willMapDispatchToProps)(SettingsSaveFilesSelect)

SettingsSaveFilesSelect.propTypes = {
  allSongs: PropTypes.array.isRequired,
  closeModalHandler: PropTypes.func.isRequired,
  closeSaveFilesSelectHandler: PropTypes.func.isRequired,
  downloadSongs: PropTypes.func.isRequired,
  downloadId: PropTypes.number,
  downloadProgress: PropTypes.number.isRequired,
  downloadNumber: PropTypes.number.isRequired,
  downloadNumberTotal: PropTypes.number.isRequired,
  downloadedSongs: PropTypes.array.isRequired,
  isDownloading: PropTypes.bool.isRequired,
  toggleDownloadInBackground: PropTypes.func.isRequired,
}
